import type { ReactNode } from "react";
import { adminPageClass } from "./adminStyles";

type AdminPageShellProps = {
  children: ReactNode;
  className?: string;
};

export default function AdminPageShell({ children, className = "" }: AdminPageShellProps) {
  return <div className={`${adminPageClass} ${className}`.trim()}>{children}</div>;
}
